// extracted by css-extract-rspack-plugin
export default {"ShareButton":"ShareButton-module__ShareButton__atGpi","Text":"ShareButton-module__Text__G_A_q"};